export default "__VITE_ASSET__BnLLL5mm__"